import { ObjectSchema } from 'yup';

export enum AddPeriod {
    None,
    Heading,
    TextField,
}

export interface CustomerLedgerCardsFilterState {
    fromDate: Date;
    toDate: Date;
    fromCustomer?: number;
    toCustomer?: number;
    fromCustomerGroup?: number;
    toCustomerGroup?: number;
    currency: string;
    showAccountsWithNoBalance: boolean;
    showOpenOnly: boolean;
    heading?: string;
    text?: string;
    layoutGroup: number;
    includeNonBookedEntries: boolean;
    addPeriodTo: AddPeriod;
}

export interface CustomerLedgerCardsFilterPayload {
    fromDate: Date;
    toDate: Date;
    fromCustomer?: number;
    toCustomer?: number;
    fromGroup?: number;
    toGroup?: number;
    currency: string;
    showAccountsWithNoBalance: boolean;
    showOpenOnly: boolean;
    heading?: string;
    text?: string;
    layoutGroup: number;
    includeNonBookedEntries: boolean;
    addPeriodTo: AddPeriod;
}

export interface CustomerLedgerCardsDataResponse {
    customerNumber: number;
    customerName: string;
    customerEmail: string | null;
    currency: string;
    date: Date;
    voucherNumber: number | null;
    journalEntryType: number;
    journalEntryNumber: number | null;
    isArtificial: boolean;
    text: string;
    amount: number;
    balance: number;
    invoiceNumber: number | null;
    draftNumber: number | null;
    voucherDisplayNumber: number | null;
    imageNumber: number | null;
    appendixNumber: number | null;
    genNumber: number | null;
}

export interface CustomerLedgerCardsTableData {
    customerNumber: number;
    customerName: string;
    customerEmail: string | undefined;
    currency: string;
    date: Date;
    voucherNumber: number | undefined;
    journalEntryType: number;
    journalEntryNumber: number | undefined;
    isArtificial: boolean;
    text: string;
    amount: number;
    balance: number;
    invoiceNumber: number | undefined;
    draftNumber: number | undefined;
    voucherDisplayNumber: number | undefined;
    imageNumber: number | undefined;
    appendixNumber: number | undefined;
    genNumber: number | undefined;
}

export enum CustomerLedgerCardsColumn {
    CustomerNumber = 'customerNumber',
    Date = 'date',
    VoucherNumber = 'voucherNumber',
    InvoiceNumber = 'invoiceNumber',
    JournalEntryType = 'journalEntryType',
    Text = 'text',
    Currency = 'currency',
    Amount = 'amount',
    Balance = 'balance',
    ImageNumber = 'imageNumber',
}

export interface CustomerLedgerCardsProps {
    applyFilters: (value: CustomerLedgerCardsFilterState) => void;
    setFilter: (value: CustomerLedgerCardsFilterState) => void;
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    hideCancelButton: boolean;
    validationSchema?: ((values: object) => ObjectSchema<{}>) | ObjectSchema<{}>;
    defaultData: CustomerLedgerCardsFilterState;
    initialData: CustomerLedgerCardsFilterState;
}
